import { render, staticRenderFns } from "./RiskLocationDNA.vue?vue&type=template&id=f48c0394&"
import script from "./RiskLocationDNA.vue?vue&type=script&lang=js&"
export * from "./RiskLocationDNA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports